import { useEffect, useState } from "react";
import { CachingService } from "../services/CachingService";

export function useGroupKeys() {
  const [results, setResults] = useState([]);
  useEffect(() => {
    const service = new CachingService();
    service.fetchGroups().then((response) => setResults(response.data));
  }, []);
  return { results };
}
